import React from "react"
import styled from "styled-components"
import Plan, { IPlanProps } from "../Plan"

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 30px 20px;
  > * {
    margin: 0 30px;
  }
  @media screen and (max-width: 963px) {
    > * {
      margin: 30px;
    }
  }
`

interface IProps {
  plans?: IPlanProps[]
}

const Plans = (props: IProps) => (
  <Wrapper className="PlansSection">
    {(props.plans || []).map(p => {
      return (
        <Plan key={`${Math.floor(Math.random() * 10)}-${p.planId}`} {...p} />
      )
    })}
  </Wrapper>
)

Plans.defaultProps = {
  plans: [],
}

export default Plans
